import './OrderDetailsProducts.css';
import ProductItem from './sub/ProductItem/ProductItem.jsx';

export default function OrderDetailsProducts({ items, deliveryPrice }) {
    const calculateTotal = () =>
        parseFloat(
            items.reduce((acc, item) => acc + item.price * item.amount, 0).toFixed(2)
        );

    const total = Number(calculateTotal()).toFixed(2); // string
    const grandTotal = (parseFloat(total) + parseFloat(deliveryPrice)).toFixed(2);



    return (
        <div className="order-products">
            <span className="order-products-label">Zamówienie</span>

            {items.map((item, index) => (
                <ProductItem key={index} item={item} />
            ))}

            <div className="order-products-sumup">
                <div className="order-products-sumup-top">
                    <Row label="Wartość koszyka:" value={`${total} zł`} />
                    <Row label="Koszt dostawy:" value={`${deliveryPrice} zł`} />
                </div>
                <div className="order-products-sumup-bottom">
                    <Row
                        label="Razem:"
                        value={`${grandTotal} zł`}
                        labelClass="bold"
                        valueClass="bold"
                    />
                </div>
            </div>
        </div>
    );
}

function Row({ label, value, labelClass = '', valueClass = '' }) {
    return (
        <div className="order-products-sumup-row">
            <span className={`order-products-sumup-left ${labelClass}`}>{label}</span>
            <span className={`order-products-sumup-right ${valueClass}`}>{value}</span>
        </div>
    );
}
